import type { DecisioningStudioWizardAllowedArgs } from "./types";

/**
 * The wizard's own audience: the flipper plus edit rights or impersonation. Shared by the edit
 * URL's navigation gate and the page that re-checks it before rendering the wizard.
 */
export const getDecisioningStudioWizardAllowed = ({
  featureOn,
  hasPermission,
  isImpersonating,
}: DecisioningStudioWizardAllowedArgs): boolean =>
  featureOn("decisioning_studio_wizard") &&
  (isImpersonating || hasPermission("appGroup", { permission: "editDecisioningStudioAgents" }));
